const dict = {
  custom: {
    name: {
      required: 'W2P_VALIDATION_NAME_REQUIRED',
      max: 'W2P_VALIDATION_NAME_MAX'
    },
    postalCode: {
      required: 'W2P_VALIDATION_POSTALCODE_REQUIRED'
    },
    address: {
      required: 'W2P_VALIDATION_ADDRESS_REQUIRED',
      max: 'W2P_VALIDATION_ADDRESS_MAX'
    },
    addressOptional: {
      max: 'W2P_VALIDATION_ADDRESS_MAX'
    },
    city: {
      required: 'W2P_VALIDATION_CITY_REQUIRED',
      alpha_spaces: 'W2P_VALIDATION_CITY_ALPHASPACES'
    },
    fullName: {
      required: 'W2P_VALIDATION_FULLNAME_REQUIRED',
      max: 'W2P_VALIDATION_FULLNAME_MAX'
    },
    email: {
      required: 'W2P_VALIDATION_EMAIL_REQUIRED',
      email: 'W2P_VALIDATION_EMAIL_FORMAT'
    },
    mobile: {
      mobile: 'W2P_VALIDATION_MOBILE_MOBILE'
    },
    contactPerson: {
      required: 'W2P_VALIDATION_CONTACT_PERSON_REQUIRED',
      max: 'W2P_VALIDATION_CONTACT_PERSON_MAX'
    },
    company: {
      required: 'W2P_VALIDATION_COMPANY_REQUIRED',
      max: 'W2P_VALIDATION_COMPANY_MAX'
    },
    organizationNumber: {
      required: 'W2P_VALIDATION_ORGANIZATION_NUMBER_REQUIRED',
      max: 'W2P_VALIDATION_ORGANIZATION_NUMBER_MAX'
    },
    multiTextField: {
      max: 'W2P_ADDRESS_VALIDATION_TEXT_LENGTH_30'
    }
  }
}

export default dict
